import { ROOM_KEYS } from '../seo/hotelFacts';

// English amenity strings stored in the rooms collection → translations.amenityNames keys.
const AMENITY_KEYS = {
  'Air Conditioning': 'airConditioning', 'Free WiFi': 'freeWifi', 'Flat-screen TV': 'flatScreenTv', 'Private Bathroom': 'privateBathroom',
  'Premium Toiletries': 'premiumToiletries', 'Minibar': 'minibar', 'Mini Bar': 'minibar', 'Writing Desk': 'writingDesk',
  'Soundproof Windows': 'soundproofWindows', 'Balcony': 'balcony', 'City View': 'cityView', 'Seating Area': 'seatingArea',
  'Family Friendly': 'familyFriendly', 'Separate Bedroom': 'separateBedroom', 'Kitchenette': 'kitchenette', 'Full Kitchen': 'fullKitchen',
  'Living Room': 'livingRoom', 'Living Area': 'livingRoom', 'Premium Furnishings': 'premiumFurnishings',
};

const known = (value, key) => (value && value !== key ? value : null);

export const amenityLabel = (amenity, t) => {
  const key = AMENITY_KEYS[amenity];
  return (key && known(t(`amenityNames.${key}`), `amenityNames.${key}`)) || amenity;
};

// English keeps the admin-managed copy; other languages use the translated room name + description.
export const localizeRoom = (room, language, t) => {
  const key = ROOM_KEYS[room.beds24Id || room.id];
  if (language === 'en' || !key) return room;
  return {
    ...room,
    name: known(t(`roomTypes.${key}`), `roomTypes.${key}`) || room.name,
    description: known(t(`roomTypes.${key}Desc`), `roomTypes.${key}Desc`) || room.description,
  };
};
